import axios from "axios";
import { url } from "../constant/url";

const Axios = axios.create({
    baseURL: url
});

Axios.interceptors.request.use((config) => {
    config.headers.Authorization = `Bearer ${localStorage.getItem("token")}`
    return config;
});

Axios.interceptors.response.use((response) => response, (error) => {
    const { response } = error;
    if (response.status === 401) {
        localStorage.removeItem("token");
        window.location = '/login';
    }

    throw error;
});

export default Axios;